import React from "react";
import PropTypes from "prop-types";
import { Link, Redirect } from "react-router-dom";
import MembersApi from "../../../services/portal-api/MembersApi";
import TextInput from "../../../components/Form/components/TextInput";
import DateTextInput from "../../../components/Form/components/TextInput/DateTextInput";
import SelectInput from "../../../components/Form/components/SelectInput";
import UpdateMemberJob from "./components/UpdateMemberJob";
import CreateMemberJob from "./components/CreateMemberJob";
import WdayVoucherJob from "./components/WdayVoucherJobs";
import BdayVoucherJob from "./components/BdayVoucherJobs";
import AuthService from "../../../services/AuthService";
import { GridLoader } from "react-spinners";
import { PulseLoader } from "react-spinners";

export default class JobSection extends React.Component {
    constructor(props) {
        super(props);
        const urlParams = new URLSearchParams(window.location.search);
        this.state = {
            category: urlParams.get("type")
                ? urlParams.get("type")
                : "update_member",
            errors: {},
            slug: "",
            result: [],
            loadmore: false,
            offset: 0,
            limit: 50,
            isLoadingJobs: true,
            filterColumn: urlParams.get("column")
                ? urlParams.get("column")
                : "",
            filterToken: urlParams.get("token") ? urlParams.get("token") : "",
            screenh: "",
            filterDateFrom: "",
            filterDateTo: "",
            filterISO: "",
            marks: [],
            all: true,
            marking: false,
            graphTime: urlParams.get("graphTime")
                ? urlParams.get("graphTime")
                : "",
            processingRetryAllJobs: false,
        };
    }

    componentDidMount() {
        // this.setState({
        //     category: 'update_member',
        // }, () => {
        //     this.tableBuilder('update_member');
        // });
        this.tableBuilder(this.state.category);
    }

    _runJob = (jobId, category, callback) => {
        MembersApi.runTheJobs(
            (response) => {
                if (response.success) {
                    callback();
                } else {
                    this.props.sessionLoadOut(response);
                }
            },
            jobId,
            category
        );
    };

    mark = (jobId) => {
        let { marks } = this.state;
        if (marks.length > 0) {
            if (
                marks.find((m) => {
                    return m == jobId;
                })
            ) {
                marks = marks.filter((m) => {
                    return m != jobId;
                });
            } else {
                marks.push(jobId);
            }
        } else {
            marks.push(jobId);
        }
        this.setState({ marks: marks }, () => {
            console.log(this.state.marks);
        });
    };

    markAll = () => {
        let { all, marks } = this.state;
        if (!all) {
            marks = [];
        } else {
            marks = [];
            this.state.result.forEach((job) => {
                if (job.failed_at) marks.push(job.id);
            });
        }
        this.setState({ marks: marks, all: marks.length > 0 ? false : true });
    };

    runBulkComplete = () => {
        this.setState(
            {
                marking: true,
            },
            () => {
                let datos = {
                    type: this.state.category,
                    jobId: this.state.marks.join(),
                };
                MembersApi.bulkMarkJobs(datos, (response) => {
                    if (response.success) {
                        this.handleReset();
                    } else {
                        this.props.sessionLoadOut(response);
                    }
                });
            }
        );
    };

    retryAllJobs = () => {
        this.setState(
            {
                processingRetryAllJobs: true,
            },
            () => {
                let data = {
                    type: this.state.category,
                    jobs: this.state.marks.join(),
                };
                MembersApi.retryAllJobs(data, (response) => {
                    if (response.success) {
                        this.handleReset();
                    } else {
                        this.props.sessionLoadOut(response);
                    }
                });
            }
        );
    };

    handleReset = (event) => {
        const category = this.state.category;
        this.setState(
            {
                errors: {},
                slug: "",
                result: [],
                loadmore: false,
                offset: 0,
                limit: 50,
                isLoadingJobs: true,
                filterColumn: "",
                filterToken: "",
                filterDateFrom: "",
                filterDateTo: "",
                filterISO: "",
                screenh: "",
                marks: [],
                all: true,
                marking: false,
                processingRetryAllJobs: false,
            },
            () => {
                this.tableBuilder(category);
            }
        );
    };

    handleInput = (event) => {
        const errors = this.state.errors;
        const name = event.target.name;
        delete errors[name];
        let data = this.state;
        let category =
            event.target.type === "checkbox"
                ? event.target.checked
                : event.target.value;
        if (name == "job_type") {
            this.setState(
                {
                    errors: {},
                    slug: "",
                    loadmore: false,
                    offset: 0,
                    limit: 50,
                    isLoadingJobs: true,
                    filterColumn: "",
                    filterToken: "",
                    filterDateFrom: "",
                    filterDateTo: "",
                    screenh: "",
                    marks: [],
                    all: true,
                    marking: false,
                    processingRetryAllJobs: false,
                },
                () => {
                    this.tableBuilder(category);
                }
            );
        } else if (name == "filterBy") {
            const column = event.target.value;
            this.setState({
                filterColumn: column,
                filterToken: "",
            });
        } else {
            const token = event.target.value;
            if (name == "Date_To" || name == "Date_From") {
                if (name == "Date_From") {
                    this.setState(
                        {
                            filterDateFrom: token,
                        },
                        () => {
                            // let to = new Date(this.state.filterDateTo).toLocaleDateString('en-GB');
                            // let from = new Date(this.state.filterDateFrom).toLocaleDateString('en-GB');
                            let from = new Date(this.state.filterDateFrom);
                            let to = new Date(this.state.filterDateTo);
                            this.setState({
                                filterToken: `${new Date(
                                    this.state.filterDateFrom
                                ).toLocaleDateString(
                                    "en-GB"
                                )} ${from.toLocaleTimeString(
                                    "en-GB"
                                )}|${new Date(
                                    this.state.filterDateTo
                                ).toLocaleDateString(
                                    "en-GB"
                                )} ${to.toLocaleTimeString("en-GB")}`,
                            });
                        }
                    );
                } else {
                    this.setState(
                        {
                            filterDateTo: token,
                        },
                        () => {
                            // let to = new Date(this.state.filterDateTo).toLocaleDateString('en-GB');
                            // let from = new Date(this.state.filterDateFrom).toLocaleDateString('en-GB');
                            // this.setState({
                            //     filterToken: from + "|" + to,
                            // });
                            let from = new Date(this.state.filterDateFrom);
                            let to = new Date(this.state.filterDateTo);
                            this.setState({
                                filterToken: `${new Date(
                                    this.state.filterDateFrom
                                ).toLocaleDateString(
                                    "en-GB"
                                )} ${from.toLocaleTimeString(
                                    "en-GB"
                                )}|${new Date(
                                    this.state.filterDateTo
                                ).toLocaleDateString(
                                    "en-GB"
                                )} ${to.toLocaleTimeString("en-GB")}`,
                            });
                        }
                    );
                }
            } else {
                this.setState({
                    filterToken: token,
                });
            }
        }
    };

    tableBuilder = (category) => {
        const localTime = new Date();
        let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let offset = localTime.getTimezoneOffset();
        MembersApi.getJobs(
            (response) => {
                console.log(response);
                if (response.success) {
                    let offset = this.state.limit + this.state.offset;
                    let loadmore = response.json.loadMore;
                    this.setState(
                        {
                            result: response.json.result,
                            category: category,
                            offset: offset,
                            loadmore: loadmore,
                            isLoadingJobs: false,
                            screenh: window.innerHeight,
                        },
                        () => {
                            console.log("upd", this.state);
                        }
                    );
                } else {
                    this.setState(
                        {
                            isLoadingJobs: false,
                        },
                        () => {
                            this.props.sessionLoadOut(response);
                        }
                    );
                }
            },
            category,
            "",
            this.state.offset,
            this.state.filterColumn,
            this.state.filterToken,
            offset,
            tz,
            this.state.graphTime
        );
    };

    handleLoadMore = (events) => {
        const localTime = new Date();
        let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let offset = localTime.getTimezoneOffset();
        this.setState({ isLoadingJobs: true });
        const category = this.state.category;
        MembersApi.getJobs(
            (response) => {
                console.log(response);
                if (response.success) {
                    const result = this.state.result;
                    response.json.result.forEach((kmm, index) => {
                        result.push(kmm);
                    });
                    let offset = this.state.limit + this.state.offset;
                    let loadmore = response.json.loadMore;
                    this.setState(
                        {
                            result: result,
                            category: category,
                            offset: offset,
                            loadmore: loadmore,
                            isLoadingJobs: false,
                            screenh: window.innerHeight,
                        },
                        () => {
                            console.log("upd", this.state);
                        }
                    );
                } else {
                    this.setState(
                        {
                            isLoadingJobs: false,
                        },
                        () => {
                            this.props.sessionLoadOut(response);
                        }
                    );
                }
            },
            category,
            "",
            this.state.offset,
            this.state.filterColumn,
            this.state.filterToken,
            offset,
            tz
        );
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const localTime = new Date();
        let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let offset = localTime.getTimezoneOffset();
        const category = this.state.category;
        this.setState(
            {
                isLoadingJobs: true,
                offset: 0,
                result: [],
            },
            () => {
                MembersApi.getJobs(
                    (response) => {
                        if (response.success) {
                            let offset = this.state.limit + this.state.offset;
                            let loadmore = response.json.loadMore;
                            this.setState(
                                {
                                    result: response.json.result,
                                    offset: offset,
                                    loadmore: loadmore,
                                    isLoadingJobs: false,
                                    screenh: window.innerHeight,
                                },
                                () => {
                                    console.log("upd", this.state);
                                }
                            );
                        } else {
                            this.setState(
                                {
                                    isLoadingJobs: false,
                                },
                                () => {
                                    this.props.sessionLoadOut(response);
                                }
                            );
                        }
                    },
                    category,
                    "",
                    this.state.offset,
                    this.state.filterColumn,
                    this.state.filterToken,
                    offset,
                    tz
                );
            }
        );
    };

    render() {
        let job_typs = [
            { key: "update_member", value: "Update Member Jobs" },
            { key: "new_member", value: "New Member Jobs" },
            { key: "welcome_promo", value: "Welcome Promotion Jobs" },
            { key: "birthday_promo", value: "Birthday Promotion Jobs" },
        ];
        let columns = [];
        let filters = <div></div>;
        let jobs = [];
        let selections = [];
        let title = "";
        let markAllButton = this.state.marks.length > 0 ? "visible" : "hide";
        let statusia = [
            { key: "success", value: "Success" },
            { key: "failed", value: "Failed" },
            { key: "pending", value: "Pending" },
            { key: "inProgress", value: "In-Progress" },
        ];
        let statusiav = [
            { key: "complete", value: "Complete" },
            { key: "incomplete", value: "Incomplete" },
        ];
        switch (this.state.category) {
            case "update_member":
                title = "Update Member Jobs";
                selections = [
                    { key: "futura_customer_id", value: "Futura ID." },
                    { key: "email", value: "Email" },
                    { key: "rewards_card_number", value: "Card No." },
                    { key: "status", value: "Status" },
                    { key: "Date", value: "Date Range" },
                ];
                columns.push(
                    <th
                        key="0"
                        style={{
                            background: "#fff",
                            verticalAlign: "top",
                            width: 17,
                        }}
                    >
                        <div className="col">
                            <input
                                className="checkbox"
                                type="checkbox"
                                onChange={this.markAll}
                                checked={!this.state.all ? true : false}
                                style={{ height: 20, width: 20 }}
                            />
                        </div>
                    </th>,
                    <th
                        key="1"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        Card No.
                    </th>,
                    <th
                        key="2"
                        style={{
                            background: "#fff",
                            verticalAlign: "top",
                            width: "19%",
                            wordBreak: "break-all",
                        }}
                    >
                        Email
                    </th>,
                    <th
                        key="3"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        Created at
                    </th>,
                    <th
                        key="4"
                        style={{
                            background: "#fff",
                            verticalAlign: "top",
                            width: "8%",
                        }}
                    >
                        Status
                    </th>,
                    <th
                        key="5"
                        style={{
                            background: "#fff",
                            verticalAlign: "top",
                            width: "10%",
                        }}
                    >
                        Failed step
                    </th>,
                    <th
                        key="6"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        {markAllButton == "visible" ? (
                            <button
                                className="btn btn--xsmall btn--open btn--color"
                                style={{
                                    fontSize: "11px",
                                    whiteSpace: "nowrap",
                                    padding: "5px 10px",
                                }}
                                onClick={this.retryAllJobs}
                            >
                                {" "}
                                {this.state.processingRetryAllJobs ? (
                                    <GridLoader color="#ffffff" size={5} />
                                ) : (
                                    "Retry All"
                                )}
                            </button>
                        ) : (
                            "Retry"
                        )}
                    </th>,
                    <th
                        key="7"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        {markAllButton == "visible" ? (
                            <button
                                className="btn btn--xsmall btn--open btn--color"
                                style={{
                                    fontSize: "11px",
                                    whiteSpace: "nowrap",
                                    padding: "5px 10px",
                                }}
                                onClick={this.runBulkComplete}
                            >
                                {" "}
                                {this.state.marking ? (
                                    <GridLoader color="#ffffff" size={5} />
                                ) : (
                                    "Complete"
                                )}
                            </button>
                        ) : (
                            "Complete"
                        )}
                    </th>,
                    <th
                        key="8"
                        style={{
                            background: "#fff",
                            verticalAlign: "top",
                            width: "15%",
                        }}
                    >
                        Progress
                    </th>
                );
                filters = (
                    <form onSubmit={this.handleSubmit}>
                        <div className="col">
                            <div className="col-5 gutter--40">
                                <div className="col">
                                    <SelectInput
                                        name="job_type"
                                        label="Select a Job Category"
                                        options={job_typs}
                                        value={this.state.category}
                                        onChange={this.handleInput}
                                        required={true}
                                    />
                                </div>
                                <div className="col">
                                    <SelectInput
                                        name="filterBy"
                                        label="Search By"
                                        options={selections}
                                        value={this.state.filterColumn}
                                        onChange={this.handleInput}
                                        disabled={false}
                                    />
                                </div>
                                {this.state.filterColumn == "status" && (
                                    <div className="col">
                                        <SelectInput
                                            name="status"
                                            label="Status"
                                            options={statusia}
                                            value={this.state.filterToken}
                                            onChange={this.handleInput}
                                            disabled={false}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn == "Date" && (
                                    <div className="col">
                                        <DateTextInput
                                            name="Date_From"
                                            label="Date From"
                                            type="datetime-local"
                                            placeholder="DD/MM/YYYY"
                                            value={this.state.filterDateFrom}
                                            onChange={this.handleInput}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn == "Date" && (
                                    <div className="col">
                                        <DateTextInput
                                            name="Date_To"
                                            label="Date To"
                                            type="datetime-local"
                                            placeholder="DD/MM/YYYY"
                                            value={this.state.filterDateTo}
                                            onChange={this.handleInput}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn ==
                                    "futura_customer_id" && (
                                    <div className="col">
                                        <TextInput
                                            name="futura_customer_id"
                                            label="Futura ID."
                                            placeholder="Enter .."
                                            value={this.state.filterToken}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn == "email" && (
                                    <div className="col">
                                        <TextInput
                                            name="email"
                                            label="Email"
                                            placeholder="Enter .."
                                            value={this.state.filterToken}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn ==
                                    "rewards_card_number" && (
                                    <div className="col">
                                        <TextInput
                                            name="rewards_card_number"
                                            label="Card No"
                                            placeholder="Enter .."
                                            value={this.state.filterToken}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn != "" && (
                                    <div
                                        className="col"
                                        style={{ paddingTop: 41 }}
                                    >
                                        <button
                                            type="submit"
                                            className="btn btn--small btn--color"
                                            style={{ marginRight: 6 }}
                                        >
                                            Search
                                        </button>
                                        <button
                                            className="btn btn--small btn--color"
                                            onClick={this.handleReset}
                                        >
                                            Reset
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </form>
                );
                this.state.result.forEach((job, index) => {
                    jobs.push(
                        <UpdateMemberJob
                            key={index}
                            jobDetails={job}
                            Job={this._runJob}
                            zindex={999999 - index}
                            markem={this.mark}
                            checked={
                                this.state.marks.find((m) => {
                                    return m == job.id;
                                })
                                    ? true
                                    : false
                            }
                            updSessionLogger={this.props.sessionLoadOut}
                        ></UpdateMemberJob>
                    );
                });
                break;

            case "new_member":
                title = "New Member Jobs";
                selections = [
                    { key: "futura_customer_id", value: "Fututa ID." },
                    { key: "email", value: "Email" },
                    { key: "rewards_card_number", value: "Card No." },
                    { key: "status", value: "Status" },
                    { key: "Date", value: "Date Range" },
                ];
                columns.push(
                    <th
                        key="0"
                        style={{
                            background: "#fff",
                            verticalAlign: "top",
                            width: 17,
                        }}
                    >
                        <div className="col">
                            <input
                                className="checkbox"
                                type="checkbox"
                                onChange={this.markAll}
                                checked={!this.state.all ? true : false}
                                style={{ height: 20, width: 20 }}
                            />
                        </div>
                    </th>,
                    <th
                        key="1"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        Card No.
                    </th>,
                    <th
                        key="2"
                        style={{
                            background: "#fff",
                            verticalAlign: "top",
                            width: "19%",
                            wordBreak: "break-all",
                        }}
                    >
                        Email
                    </th>,
                    <th
                        key="3"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        Created at
                    </th>,
                    <th
                        key="4"
                        style={{
                            background: "#fff",
                            verticalAlign: "top",
                            width: "8%",
                        }}
                    >
                        Status
                    </th>,
                    <th
                        key="5"
                        style={{
                            background: "#fff",
                            verticalAlign: "top",
                            width: "10%",
                        }}
                    >
                        Failed step
                    </th>,
                    <th
                        key="6"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        {markAllButton == "visible" ? (
                            <button
                                className="btn btn--xsmall btn--open btn--color"
                                style={{
                                    fontSize: "11px",
                                    whiteSpace: "nowrap",
                                    padding: "5px 10px",
                                }}
                                onClick={this.retryAllJobs}
                            >
                                {" "}
                                {this.state.processingRetryAllJobs ? (
                                    <GridLoader color="#ffffff" size={5} />
                                ) : (
                                    "Retry All"
                                )}
                            </button>
                        ) : (
                            "Retry"
                        )}
                    </th>,
                    <th
                        key="7"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        {markAllButton == "visible" ? (
                            <button
                                className="btn btn--xsmall btn--open btn--color"
                                onClick={this.runBulkComplete}
                            >
                                {" "}
                                Complete{" "}
                                {this.state.marking && (
                                    <img
                                        className="icon"
                                        src="/img/Gear-job.gif"
                                        style={{
                                            width: 20,
                                            height: 20,
                                            top: "34%",
                                            marginTop: -5,
                                            right: 8,
                                        }}
                                    ></img>
                                )}
                            </button>
                        ) : (
                            "Complete"
                        )}
                    </th>,
                    <th
                        key="8"
                        style={{
                            background: "#fff",
                            verticalAlign: "top",
                            width: "15%",
                        }}
                    >
                        Progress
                    </th>
                );
                filters = (
                    <form onSubmit={this.handleSubmit}>
                        <div className="col">
                            <div className="col-5 gutter--40">
                                <div className="col">
                                    <SelectInput
                                        name="job_type"
                                        label="Select a Job Category"
                                        options={job_typs}
                                        value={this.state.category}
                                        onChange={this.handleInput}
                                        required={true}
                                    />
                                </div>
                                <div className="col">
                                    <SelectInput
                                        name="filterBy"
                                        label="Search By"
                                        options={selections}
                                        value={this.state.filterColumn}
                                        onChange={this.handleInput}
                                        disabled={false}
                                    />
                                </div>
                                {this.state.filterColumn == "status" && (
                                    <div className="col">
                                        <SelectInput
                                            name="status"
                                            label="Status"
                                            options={statusia}
                                            value={this.state.filterToken}
                                            onChange={this.handleInput}
                                            disabled={false}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn == "Date" && (
                                    <div className="col">
                                        <DateTextInput
                                            name="Date_From"
                                            label="Date From"
                                            type="datetime-local"
                                            placeholder="DD/MM/YYYY"
                                            value={this.state.filterDateFrom}
                                            onChange={this.handleInput}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn == "Date" && (
                                    <div className="col">
                                        <DateTextInput
                                            name="Date_To"
                                            label="Date To"
                                            type="datetime-local"
                                            placeholder="DD/MM/YYYY"
                                            value={this.state.filterDateTo}
                                            onChange={this.handleInput}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn ==
                                    "futura_customer_id" && (
                                    <div className="col">
                                        <TextInput
                                            name="futura_customer_id"
                                            label="Futura ID."
                                            placeholder="Enter .."
                                            value={this.state.filterToken}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn == "email" && (
                                    <div className="col">
                                        <TextInput
                                            name="email"
                                            label="Email"
                                            placeholder="Enter .."
                                            value={this.state.filterToken}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn ==
                                    "rewards_card_number" && (
                                    <div className="col">
                                        <TextInput
                                            name="rewards_card_number"
                                            label="Card No"
                                            placeholder="Enter .."
                                            value={this.state.filterToken}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn != "" && (
                                    <div
                                        className="col"
                                        style={{ paddingTop: 41 }}
                                    >
                                        <button
                                            type="submit"
                                            className="btn btn--small btn--color"
                                            style={{ marginRight: 6 }}
                                        >
                                            Search
                                        </button>
                                        <button
                                            className="btn btn--small btn--color"
                                            onClick={this.handleReset}
                                        >
                                            Reset
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </form>
                );
                this.state.result.forEach((job, index) => {
                    jobs.push(
                        <CreateMemberJob
                            key={index}
                            jobDetails={job}
                            Job={this._runJob}
                            zindex={999999 - index}
                            markem={this.mark}
                            checked={
                                this.state.marks.find((m) => {
                                    return m == job.id;
                                })
                                    ? true
                                    : false
                            }
                            crtSessionLogger={this.props.sessionLoadOut}
                        ></CreateMemberJob>
                    );
                });

                break;

            case "birthday_promo":
                title = "Birthday Voucher Jobs";
                selections = [
                    { key: "customer_email", value: "Email" },
                    { key: "status", value: "Status" },
                    { key: "gift_card_number", value: "Voucher No." },
                    { key: "Date", value: "Date Range" },
                    { key: "iso_serial", value: "ISO Serial" },
                ];
                columns.push(
                    <th
                        key="0"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        Voucher No.
                    </th>,
                    <th
                        key="1"
                        style={{
                            background: "#fff",
                            verticalAlign: "top",
                            width: "19%",
                            wordBreak: "break-all",
                        }}
                    >
                        Email
                    </th>,
                    <th
                        key="2"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        Created at
                    </th>,
                    <th
                        key="3"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        Eligible
                    </th>,
                    <th
                        key="4"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        Exported
                    </th>,
                    <th
                        key="5"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        Completed
                    </th>,
                    <th
                        key="6"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        Retry
                    </th>
                );
                filters = (
                    <form onSubmit={this.handleSubmit}>
                        <div className="col">
                            <div className="col-5 gutter--40">
                                <div className="col">
                                    <SelectInput
                                        name="job_type"
                                        label="Select a Job Category"
                                        options={job_typs}
                                        value={this.state.category}
                                        onChange={this.handleInput}
                                        required={true}
                                    />
                                </div>
                                <div className="col">
                                    <SelectInput
                                        name="filterBy"
                                        label="Search By"
                                        options={selections}
                                        value={this.state.filterColumn}
                                        onChange={this.handleInput}
                                        disabled={false}
                                    />
                                </div>
                                {this.state.filterColumn == "iso_serial" && (
                                    <div className="col">
                                        <TextInput
                                            name="filterISO"
                                            label="ISO Serial"
                                            placeholder="Enter .."
                                            value={this.state.filterToken}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn == "status" && (
                                    <div className="col">
                                        <SelectInput
                                            name="status"
                                            label="Status"
                                            options={statusiav}
                                            value={this.state.filterToken}
                                            onChange={this.handleInput}
                                            disabled={false}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn == "Date" && (
                                    <div className="col">
                                        <DateTextInput
                                            name="Date_From"
                                            label="Date From"
                                            type="datetime-local"
                                            placeholder="DD/MM/YYYY"
                                            value={this.state.filterDateFrom}
                                            onChange={this.handleInput}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn == "Date" && (
                                    <div className="col">
                                        <DateTextInput
                                            name="Date_To"
                                            label="Date To"
                                            type="datetime-local"
                                            placeholder="DD/MM/YYYY"
                                            value={this.state.filterDateTo}
                                            onChange={this.handleInput}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn ==
                                    "gift_card_number" && (
                                    <div className="col">
                                        <TextInput
                                            name="gift_card_number"
                                            label="Gift Card No."
                                            placeholder="Enter .."
                                            value={this.state.filterToken}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                )}

                                {this.state.filterColumn ==
                                    "customer_email" && (
                                    <div className="col">
                                        <TextInput
                                            name="email"
                                            label="Email"
                                            placeholder="Enter .."
                                            value={this.state.filterToken}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                )}

                                {this.state.filterColumn != "" && (
                                    <div
                                        className="col"
                                        style={{ paddingTop: 41 }}
                                    >
                                        <button
                                            type="submit"
                                            className="btn btn--small btn--color"
                                            style={{ marginRight: 6 }}
                                        >
                                            Search
                                        </button>
                                        <button
                                            className="btn btn--small btn--color"
                                            onClick={this.handleReset}
                                        >
                                            Reset
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </form>
                );
                this.state.result.forEach((job, index) => {
                    jobs.push(
                        <BdayVoucherJob
                            key={index}
                            jobDetails={job}
                            Job={this._runJob}
                            bdaySessionLogger={this.props.sessionLoadOut}
                        ></BdayVoucherJob>
                    );
                });
                break;

            case "welcome_promo":
                title = "Welcome Voucher Jobs";
                selections = [
                    { key: "customer_email", value: "Email" },
                    { key: "status", value: "Status" },
                    { key: "gift_card_number", value: "Voucher No." },
                    { key: "Date", value: "Date Range" },
                    { key: "iso_serial", value: "ISO Serial" },
                ];
                columns.push(
                    <th
                        key="0"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        Voucher No.
                    </th>,
                    <th
                        key="1"
                        style={{
                            background: "#fff",
                            verticalAlign: "top",
                            width: "19%",
                            wordBreak: "break-all",
                        }}
                    >
                        Email
                    </th>,
                    <th
                        key="2"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        Created at
                    </th>,
                    <th
                        key="3"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        Eligible
                    </th>,
                    <th
                        key="4"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        Exported
                    </th>,
                    <th
                        key="5"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        Completed
                    </th>,
                    <th
                        key="6"
                        style={{ background: "#fff", verticalAlign: "top" }}
                    >
                        Retry
                    </th>
                );
                filters = (
                    <form onSubmit={this.handleSubmit}>
                        <div className="col">
                            <div className="col-5 gutter--40">
                                <div className="col">
                                    <SelectInput
                                        name="job_type"
                                        label="Select a Job Category"
                                        options={job_typs}
                                        value={this.state.category}
                                        onChange={this.handleInput}
                                        required={true}
                                    />
                                </div>
                                <div className="col">
                                    <SelectInput
                                        name="filterBy"
                                        label="Search By"
                                        options={selections}
                                        value={this.state.filterColumn}
                                        onChange={this.handleInput}
                                        disabled={false}
                                    />
                                </div>
                                {this.state.filterColumn == "iso_serial" && (
                                    <div className="col">
                                        <TextInput
                                            name="filterISO"
                                            label="ISO Serial"
                                            placeholder="Enter .."
                                            value={this.state.filterToken}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn == "status" && (
                                    <div className="col">
                                        <SelectInput
                                            name="status"
                                            label="Status"
                                            options={statusiav}
                                            value={this.state.filterToken}
                                            onChange={this.handleInput}
                                            disabled={false}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn == "Date" && (
                                    <div className="col">
                                        <DateTextInput
                                            name="Date_From"
                                            label="Date From"
                                            type="datetime-local"
                                            placeholder="DD/MM/YYYY"
                                            value={this.state.filterDateFrom}
                                            onChange={this.handleInput}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn == "Date" && (
                                    <div className="col">
                                        <DateTextInput
                                            name="Date_To"
                                            label="Date To"
                                            type="datetime-local"
                                            placeholder="DD/MM/YYYY"
                                            value={this.state.filterDateTo}
                                            onChange={this.handleInput}
                                        />
                                    </div>
                                )}
                                {this.state.filterColumn ==
                                    "gift_card_number" && (
                                    <div className="col">
                                        <TextInput
                                            name="gift_card_number"
                                            label="Gift Card No."
                                            placeholder="Enter .."
                                            value={this.state.filterToken}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                )}

                                {this.state.filterColumn ==
                                    "customer_email" && (
                                    <div className="col">
                                        <TextInput
                                            name="email"
                                            label="Email"
                                            placeholder="Enter .."
                                            value={this.state.filterToken}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                )}

                                {this.state.filterColumn != "" && (
                                    <div
                                        className="col"
                                        style={{ paddingTop: 41 }}
                                    >
                                        <button
                                            type="submit"
                                            className="btn btn--small btn--color"
                                            style={{ marginRight: 6 }}
                                        >
                                            Search
                                        </button>
                                        <button
                                            className="btn btn--small btn--color"
                                            onClick={this.handleReset}
                                        >
                                            Reset
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </form>
                );
                this.state.result.forEach((job, index) => {
                    jobs.push(
                        <WdayVoucherJob
                            key={index}
                            jobDetails={job}
                            Job={this._runJob}
                            wdaySessionLogger={this.props.sessionLoadOut}
                        ></WdayVoucherJob>
                    );
                });
                break;

            default:
                break;
        }

        $(document).ready(function () {
            $(".scrollToTop").hide();
            console.log(window.innerHeight);
            //Check to see if the window is top if not then display button
            $(window).scroll(function () {
                if ($(this).scrollTop() > 300) {
                    console.log("sd");
                    $(".scrollToTop").show();
                } else {
                    $(".scrollToTop").hide();
                }
            });
        });

        let loaderOffset = {
            top: 200,
            position: "absolute",
            left: "50%",
        };

        if (this.state.offset != 0) {
            loaderOffset = {
                bottom: 400,
                position: "absolute",
                left: "50%",
            };
        }

        return (
            <div>
                <div className="col gutter--40">
                    <div className="col">{filters}</div>
                    <div
                        className="col"
                        style={{ borderBottom: "1px solid #ccc" }}
                    >
                        <div className="col">
                            <h2
                                className="text--light text--color text--40 margin--40--top"
                                style={{ float: "left" }}
                            >
                                {title}
                            </h2>
                        </div>
                    </div>
                </div>
                <div
                    className="table--overflow clearfix"
                    style={{ overflow: "hidden" }}
                >
                    {/* {this.state.isLoadingJobs && (
                        <div
                            style={{
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                height: "50%",
                                width: "50%",
                                background: "#fff",
                                zIndex: 7777,
                                opacity: 0.8,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <div
                                className="sk-fading-circle"
                                style={loaderOffset}
                            >
                                <div className="sk-circle1 sk-circle" />
                                <div className="sk-circle2 sk-circle" />
                                <div className="sk-circle3 sk-circle" />
                                <div className="sk-circle4 sk-circle" />
                                <div className="sk-circle5 sk-circle" />
                                <div className="sk-circle6 sk-circle" />
                                <div className="sk-circle7 sk-circle" />
                                <div className="sk-circle8 sk-circle" />
                                <div className="sk-circle9 sk-circle" />
                                <div className="sk-circle10 sk-circle" />
                                <div className="sk-circle11 sk-circle" />
                                <div className="sk-circle12 sk-circle" />
                            </div>
                        </div>
                    )} */}
                    <table style={{ fontSize: 15 }}>
                        <thead>
                            <tr>{columns}</tr>
                        </thead>
                        <tbody>
                            {this.state.isLoadingJobs ? (
                                <PulseLoader color="#000" size={5} />
                            ) : (
                                jobs
                            )}
                            {jobs.length === 0 && (
                                <tr>
                                    <td colSpan={columns.length}>
                                        No results founds.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {this.state.loadmore && (
                        <button
                            onClick={this.handleLoadMore}
                            style={{
                                position: "relative",
                                left: "50%",
                                bottom: 20,
                                marginTop: 60,
                                zIndex: 9999,
                                padding: "5px 5px 5px",
                                fontSize: 12,
                                borderRadius: 23,
                                background: "#2170c3",
                                fontWeight: 600,
                                color: "white",
                                width: 112,
                                boxShadow: "0px 0px 6px #58626c",
                            }}
                        >
                            load more
                        </button>
                    )}
                </div>
            </div>
        );
    }
}
